import { useEffect, useState } from "react";
import { NotificationResource } from "models/Resources/NotificationResource";
import { NotificationType } from "constants/NotificationConstants";
import { useAppSelector } from "hooks/StoreHooks";
import { getNewImportantNotification } from "store/Slices/gridEventSlice";

export function useImportantNotificationPopup(
  notifications: NotificationResource[] | undefined,
  { autoHideMs = 6000 } = {}
) {
  const newImportantNotification = useAppSelector(getNewImportantNotification);
  const [visible, setVisible] = useState(false);
  const [message, setMessage] = useState<string | null>(null);

  useEffect(() => {
    if (
      !newImportantNotification ||
      !notifications ||
      notifications.length === 0
    )
      return;

    const latestNotification = notifications[0];
    const isImportant =
      latestNotification.type?.toLowerCase?.() ===
      NotificationType.IMPORTANT.valueOf();

    if (
      isImportant &&
      newImportantNotification.notificationId ==
        latestNotification.notificationId
    ) {
      setMessage(latestNotification.text || "Important notification");
      setVisible(true);
      const t = setTimeout(() => setVisible(false), autoHideMs);
      return () => clearTimeout(t);
    }
  }, [newImportantNotification, autoHideMs]);

  return {
    isNotificationIncoming: visible,
    notificationMessage: message,
    closeNotification: () => setVisible(false),
  };
}
